/* eslint-disable @typescript-eslint/no-floating-promises */
import { useState, useEffect } from 'react';
import { useOpts } from './context';
var CK_THEME_WORKSPACES = new Set([
    'Credit Karma Theme Testing',
    'Credit Karma',
]);
/*
 * Apparently Aspiration workspace got created with a blankspace at the end, we might
 * update the db to fix it, but this is a bandaid solution for now
 */
var ASPIRATION_THEME_WORKSPACES = new Set([
    'Aspiration ',
    'Aspiration',
    'Aspiration Theme Testing',
]);
var CITADEL_THEME_WORKSPACES = new Set([
    'Citadel CU',
    'Citadel Theme Testing',
]);
var CITIZENS_THEME_WORKSPACES = new Set([
    'Citizens',
    'Citizens Theme Testing',
]);
var DISCOVER_HELOC = new Set([
    'Discover HELOC',
    'Discover HELOC Theme Testing',
]);
var PEACH_STATE_BANK = new Set([
    'Peach State Bank',
    'Peach State Bank Theme Testing',
]);
var FLOW_THEME_WORKSPACES = new Set(['Flow', 'Flow Theme Testing']);
var PLAID_THEME_WORKSPACES = new Set([
    // Plaid's actual workspace
    'Plaid',
    // Internal workspace for testing purposes
    'Plaid Theme Testing',
]);
var SBKC_THEME_WORKSPACES = new Set(['SBKC']);
var DOORDASH_THEME_WORKSPACES = new Set(['DoorDash']);
var PSECU_THEME_WORKSPACES = new Set([
    // PSECU's actual workspace
    'PSECU',
    // Internal workspace for testing purposes
    'PSECU Theme Testing',
]);
var MEA_FINANCIAL_THEME_WORKSPACES = new Set([
    'MEA Financial',
    'MEA Financial Theme Testing',
    // For demo purposes
    'Test Credit Union',
]);
var ACORNS_THEME_WORKSPACES = new Set(['Acorns', 'Acorns Theme Testing']);
var NINJA_HOLDINGS_WORKSPACES = new Set(['CreditNinja']);
var ONE_FINANCE_THEME_WORKSPACES = new Set(['One Finance']);
var AFFINITY_THEME_WORKSPACES = new Set(['Affinity FCU']);
var REDWOOD_CU_THEME_WORKSPACES = new Set([
    'Redwood CU',
    'Redwood CU Theme Testing',
]);
var CBNA_THEME_WORKSPACES = new Set(['CBNA']);
var NASSAU_FCU_THEME_WORKSPACES = new Set(['Nassau Financial CU']);
var KEY_BANK_THEME_WORKSPACES = new Set(['Key Bank']);
var ROBINHOOD_THEME_WORKSPACES = new Set(['Robinhood']);
export var useTheme = function () {
    var _a;
    var opts = useOpts();
    var _b = useState(null), theme = _b[0], setTheme = _b[1];
    useEffect(function () {
        if (CK_THEME_WORKSPACES.has(opts.linkTokenPayload.workspaceName)) {
            import(
            /*
              webpackChunkName: "ck-fonts",
            */
            '../theme/ck-fonts');
            import(
            /*
              webpackChunkName: "ck-theme",
            */
            '../theme/credit-karma').then(function (creditKarmaTheme) {
                setTheme(creditKarmaTheme.default);
            });
        }
        else if (ONE_FINANCE_THEME_WORKSPACES.has(opts.linkTokenPayload.workspaceName)) {
            import(
            /*
              webpackChunkName: "one-finance-fonts",
            */
            '../theme/one-finance-fonts');
            import(
            /*
              webpackChunkName: "one-finance-theme",
            */
            '../theme/one-finance').then(function (oneFinanceTheme) {
                setTheme(oneFinanceTheme.default);
            });
        }
        else if (ASPIRATION_THEME_WORKSPACES.has(opts.linkTokenPayload.workspaceName)) {
            import(
            /*
              webpackChunkName: "aspiration-fonts",
            */
            '../theme/aspiration-fonts');
            import(
            /*
              webpackChunkName: "asp-theme",
            */
            '../theme/aspiration').then(function (aspirationTheme) {
                setTheme(aspirationTheme.default);
            });
        }
        else if (CITADEL_THEME_WORKSPACES.has(opts.linkTokenPayload.workspaceName)) {
            import(
            /*
              webpackChunkName: "citadel-theme",
            */
            '../theme/citadel').then(function (citadelTheme) {
                setTheme(citadelTheme.default);
            });
        }
        else if (CITIZENS_THEME_WORKSPACES.has(opts.linkTokenPayload.workspaceName)) {
            import(
            /*
              webpackChunkName: "citizens-fonts",
            */
            '../theme/citizens-fonts');
            import(
            /*
              webpackChunkName: "citizens-theme",
            */
            '../theme/citizens').then(function (citizensTheme) {
                setTheme(citizensTheme.default);
            });
        }
        else if (DISCOVER_HELOC.has(opts.linkTokenPayload.workspaceName)) {
            import(
            /*
              webpackChunkName: "discover-heloc-fonts",
            */
            '../theme/discover-heloc-fonts');
            import(
            /*
              webpackChunkName: "discover-heloc-theme",
            */
            '../theme/discover-heloc').then(function (discoverHelocTheme) {
                setTheme(discoverHelocTheme.default);
            });
        }
        else if (PEACH_STATE_BANK.has(opts.linkTokenPayload.workspaceName)) {
            import(
            /*
              webpackChunkName: "peach-state-bank-theme",
            */
            '../theme/peach-state-bank').then(function (peachStateBankTheme) {
                setTheme(peachStateBankTheme.default);
            });
        }
        else if (FLOW_THEME_WORKSPACES.has(opts.linkTokenPayload.workspaceName)) {
            import(
            /*
              webpackChunkName: "flow-theme",
            */
            '../theme/flow').then(function (flowTheme) {
                setTheme(flowTheme.default);
            });
        }
        else if (PLAID_THEME_WORKSPACES.has(opts.linkTokenPayload.workspaceName)) {
            import(
            /*
              webpackChunkName: "plaid-fonts",
            */
            '../theme/plaid-fonts');
            import(
            /*
              webpackChunkName: "plaid-theme",
            */
            '../theme/plaid').then(function (plaidTheme) {
                setTheme(plaidTheme.default);
            });
        }
        else if (PSECU_THEME_WORKSPACES.has(opts.linkTokenPayload.workspaceName)) {
            import(
            /*
              webpackChunkName: "psecu-theme",
            */
            '../theme/psecu').then(function (psecuTheme) {
                setTheme(psecuTheme.default);
            });
        }
        else if (SBKC_THEME_WORKSPACES.has(opts.linkTokenPayload.workspaceName)) {
            import(
            /*
              webpackChunkName: "sbank-theme",
            */
            '../theme/sbkc').then(function (sbkcTheme) {
                setTheme(sbkcTheme.default);
            });
        }
        else if (DOORDASH_THEME_WORKSPACES.has(opts.linkTokenPayload.workspaceName)) {
            import(
            /*
              webpackChunkName: "doordash-theme",
            */
            '../theme/doordash').then(function (doordashTheme) {
                setTheme(doordashTheme.default);
            });
        }
        else if (NINJA_HOLDINGS_WORKSPACES.has(opts.linkTokenPayload.workspaceName)) {
            import(
            /*
              webpackChunkName: "ninja-theme",
            */
            '../theme/ninja').then(function (ninjaTheme) {
                setTheme(ninjaTheme.default);
            });
        }
        else if (MEA_FINANCIAL_THEME_WORKSPACES.has(opts.linkTokenPayload.workspaceName)) {
            import(
            /*
              webpackChunkName: "mea-theme",
            */
            '../theme/mea-financial').then(function (meaFinancialTheme) {
                setTheme(meaFinancialTheme.default);
            });
        }
        else if (AFFINITY_THEME_WORKSPACES.has(opts.linkTokenPayload.workspaceName)) {
            import(
            /*
              webpackChunkName: "affinity-theme",
            */
            '../theme/affinity').then(function (affinityTheme) {
                setTheme(affinityTheme.default);
            });
        }
        else if (ACORNS_THEME_WORKSPACES.has(opts.linkTokenPayload.workspaceName)) {
            import(
            /*
              webpackChunkName: "acorns-theme",
            */
            '../theme/acorns').then(function (acornsTheme) {
                setTheme(acornsTheme.default);
            });
        }
        else if (REDWOOD_CU_THEME_WORKSPACES.has(opts.linkTokenPayload.workspaceName)) {
            import(
            /*
              webpackChunkName: "redwood-cu-theme",
            */
            '../theme/redwood-cu').then(function (redwoodTheme) {
                setTheme(redwoodTheme.default);
            });
        }
        else if (CBNA_THEME_WORKSPACES.has(opts.linkTokenPayload.workspaceName)) {
            import(
            /*
              webpackChunkName: "cbna-theme",
            */
            '../theme/cbna').then(function (cbnaTheme) {
                setTheme(cbnaTheme.default);
            });
        }
        else if (NASSAU_FCU_THEME_WORKSPACES.has(opts.linkTokenPayload.workspaceName)) {
            import(
            /*
              webpackChunkName: "nassau-fcu-theme",
            */
            '../theme/nassau-fcu').then(function (nassauFcuTheme) {
                setTheme(nassauFcuTheme.default);
            });
        }
        else if (KEY_BANK_THEME_WORKSPACES.has(opts.linkTokenPayload.workspaceName)) {
            import(
            /*
              webpackChunkName: "key-bank-theme",
            */
            '../theme/key-bank').then(function (keyBankTheme) {
                setTheme(keyBankTheme.default);
            });
        }
        else if (ROBINHOOD_THEME_WORKSPACES.has(opts.linkTokenPayload.workspaceName)) {
            import(
            /*
              webpackChunkName: "robinhood-theme",
            */
            '../theme/robinhood').then(function (robinhoodTheme) {
                setTheme(robinhoodTheme.default);
            });
        }
        else {
            setTheme({});
        }
    }, [
        opts.linkTokenPayload.workspaceName,
        opts.loadedPlatform,
        (_a = opts.linkTokenPayload) === null || _a === void 0 ? void 0 : _a.mode,
    ]);
    return theme;
};
export var useAppLogo = function () {
    var opts = useOpts();
    var _a = useState(), appLogo = _a[0], setAppLogo = _a[1];
    useEffect(function () {
        if (ASPIRATION_THEME_WORKSPACES.has(opts.linkTokenPayload.workspaceName)) {
            import(
            /*
              webpackChunkName: "greenfi-logo",
                */
            './assets/greenfi-logo.png').then(function (greenfiLogo) {
                setAppLogo({ src: greenfiLogo.default, hidePinwheel: false });
            });
        }
        else if (FLOW_THEME_WORKSPACES.has(opts.linkTokenPayload.workspaceName)) {
            import(
            /*
              webpackChunkName: "flow-logo",
                */
            './assets/flow-logo.png').then(function (flowLogo) {
                setAppLogo({ src: flowLogo.default, hidePinwheel: true });
            });
        }
        else if (CITADEL_THEME_WORKSPACES.has(opts.linkTokenPayload.workspaceName)) {
            import(
            /*
              webpackChunkName: "citadel-logo",
                */
            './assets/citadel-logo.png').then(function (citadelLogo) {
                setAppLogo({ src: citadelLogo.default, hidePinwheel: true });
            });
        }
        else if (PSECU_THEME_WORKSPACES.has(opts.linkTokenPayload.workspaceName)) {
            import(
            /*
              webpackChunkName: "psecu-logo",
                */
            './assets/psecu-logo.png').then(function (psecuLogo) {
                setAppLogo({ src: psecuLogo.default, hidePinwheel: true });
            });
        }
        else if (SBKC_THEME_WORKSPACES.has(opts.linkTokenPayload.workspaceName)) {
            import(
            /*
              webpackChunkName: "sbkc-logo",
                */
            './assets/sbkc-logo.png').then(function (sbkcLogo) {
                setAppLogo({ src: sbkcLogo.default, hidePinwheel: true });
            });
        }
        else if (REDWOOD_CU_THEME_WORKSPACES.has(opts.linkTokenPayload.workspaceName)) {
            import(
            /*
              webpackChunkName: "redwood-cu-logo",
                */
            './assets/redwood-cu-logo.png').then(function (redwoodCuLogo) {
                setAppLogo({ src: redwoodCuLogo.default, hidePinwheel: true });
            });
        }
        else if (CBNA_THEME_WORKSPACES.has(opts.linkTokenPayload.workspaceName)) {
            import(
            /*
              webpackChunkName: "cbna-logo",
                */
            './assets/cbna_mark.png').then(function (cbnaLogo) {
                setAppLogo({ src: cbnaLogo.default, hidePinwheel: false });
            });
        }
    }, [opts.linkTokenPayload.workspaceName]);
    return appLogo;
};
export var useLoaderConfig = function () {
    var opts = useOpts();
    var _a = useState(null), loaderConfig = _a[0], setLoaderConfig = _a[1];
    var featureFlags = opts.featureFlags;
    useEffect(function () {
        if (featureFlags.genericLoader) {
            setLoaderConfig({
                type: 'circle',
            });
        }
        else if (CK_THEME_WORKSPACES.has(opts.linkTokenPayload.workspaceName)) {
            import(
            /*
              webpackChunkName: "ck-loading",
            */
            '../theme/credit-karma-loading.json').then(function (creditKarmaLoader) {
                setLoaderConfig({
                    type: 'lottie',
                    data: creditKarmaLoader,
                    width: 96,
                    height: 96,
                });
            });
        }
        else if (ASPIRATION_THEME_WORKSPACES.has(opts.linkTokenPayload.workspaceName)) {
            import(
            /*
              webpackChunkName: "asp-loading",
            */
            './assets/asp-loading.svg').then(function (aspirationLoader) {
                setLoaderConfig({
                    // type: 'circle',
                    type: 'img',
                    src: aspirationLoader.default,
                    sx: {
                        backgroundPosition: 'center',
                        backgroundSize: 'cover',
                    },
                });
            });
        }
        else {
            setLoaderConfig({
                type: 'logo',
            });
        }
    }, [featureFlags, opts.linkTokenPayload.workspaceName]);
    return loaderConfig;
};
